import { createSlice } from "@reduxjs/toolkit";
import { getEnvironment, updateEnvironment } from "./settingAction";

const initialState = {
  data: null,
  loading: false,
  error: null,
  updateSuccess: false,
};

const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetError(state) {
      state.error = null;
    },
    resetUpdateSuccess(state) {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getEnvironment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(getEnvironment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEnvironment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateEnvironment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateEnvironment.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(updateEnvironment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError, resetUpdateSuccess } = settingSlice.actions;

export default settingSlice.reducer;
